import axiosInstance from '../../../../config/axiosInstance';
import { SettingValueValidation } from "../../views/SettingValue/Validation/SettingValueValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};
const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
event.preventDefault();
  const formErrors = SettingValueValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
      const response = await axiosInstance.post(`/Setup/CreateSettingValue`, formData);
      setFormData({
        vc_ValueName: '',
        vc_Value:'',
        SettingID:''
        
        // Reset other fields as needed
      });
      redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };